import 'regenerator-runtime/runtime'

import { initContract, login, logout } from './utils'

import getConfig from './config'
const { networkId } = getConfig(process.env.NODE_ENV || 'development')

// global variable used throughout
let isFirstMessage = true;

const submitButton = document.querySelector('form button');

function randInt(min, max) {
    let range = max - min + 1;
    let rand = Math.floor(Math.random() * range);
    let ret = min + rand;
    if (ret>max) ret = max;
    return ret;
}

function clearMessages() {
    isFirstMessage = true;
    let objMessages = document.querySelector("#messages");
    objMessages.innerHTML = `Please enter the name and click "Say hello" button to start!`;
}
window.clearMessages = clearMessages;

function getRandomColor() {
    let colors = ["red", "orange", "green", "blue", "magenta", "purple", "black", "maroon", "brown"];
    return colors[randInt(0, colors.length-1)];
}

function appendMessage(message) {
    if (!message) return;

    let date = new Date();
    let strDate = date.toLocaleDateString() + " " + date.toLocaleTimeString();

    let color = getRandomColor();
    let html = `<div style="padding-top: 5px;"><span style="font-size: smaller;">${strDate}</span>: <font color="${color}">${message}</font></div>`;
    let objMessages = document.querySelector("#messages");
    
    if (isFirstMessage) {
        objMessages.innerHTML = html;
    } else {
        let oldHtml = objMessages.innerHTML;
        objMessages.innerHTML = html + oldHtml;
    }
    isFirstMessage = false;
}

document.querySelector('form').onsubmit = async (event) => {
    event.preventDefault()

    // get elements from the form using their id attribute
    const { fieldset, greeting } = event.target.elements

    // disable the form while the value gets updated on-chain
    fieldset.disabled = true

    try {
        // make an update call to the smart contract
        let message = await window.contract.hello({
            account_id: greeting.value
        });
        appendMessage(message);
        greeting.value = "";
    } catch (e) {
        alert(
            'Something went wrong! ' +
            'Maybe you need to sign out and back in? ' +
            'Check your browser console for more info.'
        )
        throw e
    } finally {
        // re-enable the form, whether the call succeeded or failed
        fieldset.disabled = false;
    }

    // disable the save button, since it now matches the persisted value
    submitButton.disabled = true

    // show notification
    document.querySelector('[data-behavior=notification]').style.display = 'block';

    // remove notification again after css animation completes
    // this allows it to be shown again next time the form is submitted
    setTimeout(() => {
        document.querySelector('[data-behavior=notification]').style.display = 'none';
    }, 8000);
}

document.querySelector('input#greeting').oninput = (event) => {
    if (event.target.value !== "") {
        submitButton.disabled = false
    } else {
        submitButton.disabled = true
    }
}

document.querySelector('#sign-in-button').onclick = login
document.querySelector('#sign-out-button').onclick = logout

// Display the signed-out-flow container
function signedOutFlow() {
    document.querySelector('#signed-out-flow').style.display = 'block'
}

// Displaying the signed in flow container and fill in account-specific data
function signedInFlow() {
    document.querySelector('#signed-in-flow').style.display = 'block'

    document.querySelectorAll('[data-behavior=account-id]').forEach(el => {
        el.innerText = window.accountId
    })

    // populate links in the notification box
    const accountLink = document.querySelector('[data-behavior=notification] a:nth-of-type(1)')
    accountLink.href = accountLink.href + window.accountId
    accountLink.innerText = '@' + window.accountId
    const contractLink = document.querySelector('[data-behavior=notification] a:nth-of-type(2)')
    contractLink.href = contractLink.href + window.contract.contractId
    contractLink.innerText = '@' + window.contract.contractId

    // update with selected networkId
    accountLink.href = accountLink.href.replace('testnet', networkId)
    contractLink.href = contractLink.href.replace('testnet', networkId)
}

// `nearInitPromise` gets called on page load
window.nearInitPromise = initContract()
    .then(() => {
        if (window.walletConnection.isSignedIn()) signedInFlow()
        else signedOutFlow()
    })
    .catch(console.error)
